import { STATUS_COLOR } from '@constants/statusColor';

export function formatHttpStatus(raw) {
  if (raw === undefined || raw === null || raw === '') {
    return null;
  }
  const n = Number(raw);
  if (!isFinite(n)) {
    return null;
  }
  if (n <= 0) {
    return 'No HTTP response';
  }
  return String(n);
}

export function getHttpStatusColor(code) {
  const n = Number(code);
  if (!isFinite(n)) {
    return STATUS_COLOR.WARNING;
  }
  return n === 200 || n === 201 ? STATUS_COLOR.OK : STATUS_COLOR.WARNING;
}
